<template>
  <div v-if="groupName" class="group-header-container" :class="{ 'with-image': showImages && groupData?.image_url }">
    <div v-if="showImages && groupData?.image_url" class="group-image-background" :style="groupImageStyle">
      <div class="group-header-content">
        <h2 class="group-title">{{ groupName }}</h2>
        <div v-if="!shared || canEditGroups || canDeleteGroups || canReorderGroups" class="group-button-container no-print">
          <v-btn
            v-if="(!shared || canReorderGroups) && !isFirst"
            icon="mdi-chevron-up"
            size="small"
            variant="text"
            color="white"
            @click="$emit('moveUp', groupData)"
            class="group-edit-btn group-reorder-btn"
            title="Move group up"
          ></v-btn>
          <v-btn
            v-if="(!shared || canReorderGroups) && !isLast"
            icon="mdi-chevron-down"
            size="small"
            variant="text"
            color="white"
            @click="$emit('moveDown', groupData)"
            class="group-edit-btn group-reorder-btn"
            title="Move group down"
          ></v-btn>
          <v-btn
            v-if="!shared || canEditGroups"
            icon="mdi-pencil"
            size="small"
            variant="text"
            color="white"
            @click="$emit('edit', groupData)"
            class="group-edit-btn"
          ></v-btn>
          <v-btn
            v-if="!shared || canDeleteGroups"
            icon="mdi-delete"
            size="small"
            variant="text"
            color="white"
            @click="$emit('delete', groupData)"
            class="group-edit-btn group-delete-btn"
          ></v-btn>
        </div>
      </div>
    </div>
    <div v-else class="group-header-simple">
      <div class="group-header-content-simple">
        <h2 class="group-title">{{ groupName }}</h2>
        <div v-if="!shared || canEditGroups || canDeleteGroups || canReorderGroups" class="group-button-container no-print">
        <v-btn
          v-if="(!shared || canReorderGroups) && !isFirst"
          icon="mdi-chevron-up"
          size="small"
          variant="text"
          @click="$emit('moveUp', groupData)"
          class="group-edit-btn group-reorder-btn"
          title="Move group up"
        ></v-btn>
        <v-btn
          v-if="(!shared || canReorderGroups) && !isLast"
          icon="mdi-chevron-down"
          size="small"
          variant="text"
          @click="$emit('moveDown', groupData)"
          class="group-edit-btn group-reorder-btn"
          title="Move group down"
        ></v-btn>
        <v-btn
          v-if="!shared || canEditGroups"
          icon="mdi-pencil"
          size="small"
          variant="text"
          @click="$emit('edit', groupData)"
          class="group-edit-btn"
        ></v-btn>
        <v-btn
          v-if="!shared || canDeleteGroups"
          icon="mdi-delete"
          size="small"
          variant="text"
          @click="$emit('delete', groupData)"
          class="group-edit-btn group-delete-btn"
        ></v-btn>
        </div>
      </div>
    </div>
  </div>
  <h2 v-else class="group-title">General</h2>
</template>

<script>
export default {
  name: 'GroupHeader',
  props: {
    groupName: {
      type: String,
      default: null
    },
    groupData: {
      type: Object,
      default: null
    },
    showImages: {
      type: Boolean,
      default: true
    },
    shared: {
      type: Boolean,
      default: false
    },
    groupImageStyle: {
      type: Object,
      default: () => ({})
    },
    canEditGroups: {
      type: Boolean,
      default: false
    },
    canDeleteGroups: {
      type: Boolean,
      default: false
    },
    canReorderGroups: {
      type: Boolean,
      default: false
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  emits: ['edit', 'delete', 'moveUp', 'moveDown']
}
</script>

<style scoped>
.group-header-container {
  width: 100%;
  margin-bottom: 0.75rem;
}

.group-image-background {
  width: 100%;
  aspect-ratio: 24/5;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.group-header-content {
  width: 100%;
  text-align: left;
  padding: 16px 24px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
}

.group-header-content-simple {
  display: flex;
  align-items: center;
  gap: 12px;
}

.group-header-simple {
  padding: 0.5rem 0;
  border-bottom: 1px solid #ddd;
  margin-bottom: 0.5rem;
}

.group-title {
  font-size: 1.25rem;
  font-weight: bold;
  margin: 0;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding-bottom: 0.25rem;
  flex: 1;
}

.group-header-container:not(.with-image) .group-title {
  margin-bottom: 0.5rem;
}

.group-image-background .group-title {
  color: white;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.7);
  border-bottom: none;
  padding-bottom: 0;
  flex: 1;
}

.group-button-container {
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
}

.group-header-container:hover .group-button-container,
.group-header-simple:hover .group-button-container {
  opacity: 1;
}

.group-edit-btn {
  min-width: 24px !important;
  width: 24px !important;
  height: 24px !important;
  flex-shrink: 0;
}

/* Styling for buttons with image background */
.group-image-background .group-button-container .group-edit-btn {
  background-color: rgba(0, 0, 0, 0.3) !important;
  backdrop-filter: blur(4px);
}

.group-image-background .group-button-container .group-edit-btn:hover {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

/* Styling for buttons without image background */
.group-header-simple .group-button-container .group-edit-btn {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.group-header-simple .group-button-container .group-edit-btn:hover {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

/* Special styling for delete button */
.group-delete-btn:hover {
  background-color: rgba(244, 67, 54, 0.2) !important;
}

.group-delete-btn:hover .v-icon {
  color: #f44336 !important;
}

/* Special styling for reorder buttons */
.group-reorder-btn:hover {
  background-color: rgba(33, 150, 243, 0.2) !important;
}

.group-reorder-btn:hover .v-icon {
  color: #2196F3 !important;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .group-header-content {
    padding: 12px 16px;
    gap: 8px;
  }
  
  .group-title {
    font-size: 1.1rem;
  }
  
  .group-edit-btn {
    min-width: 20px !important;
    width: 20px !important;
    height: 20px !important;
  }
  
  .group-button-container {
    gap: 2px;
  }
}

@media (max-width: 480px) {
  .group-header-content {
    padding: 8px 12px;
    gap: 6px;
  }
  
  .group-title {
    font-size: 1rem;
  }
  
  .group-edit-btn {
    min-width: 18px !important;
    width: 18px !important;
    height: 18px !important;
  }
}
</style>